import React, { useEffect, useRef, useState } from 'react';

export default function AnalyticsPanel({
  title,
  subtitle,
  children,
  footer,
  collapsible = true,
  collapsedHeight = 260,
}) {
  const bodyRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);

  useEffect(() => {
    if (!collapsible) {
      setShowToggle(false);
      return;
    }

    const checkOverflow = () => {
      if (!bodyRef.current) return;
      const needsToggle = bodyRef.current.scrollHeight > collapsedHeight + 4;
      setShowToggle(needsToggle);
      if (!needsToggle) {
        setExpanded(false);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [children, collapsible, collapsedHeight]);

  return (
    <section className="analytics-panel">
      <header className="analytics-panel-header">
        <div>
          <h4 className="analytics-panel-title">{title}</h4>
          {subtitle && <p className="analytics-panel-subtitle">{subtitle}</p>}
        </div>
      </header>
      <div
        ref={bodyRef}
        className={`analytics-panel-body ${expanded ? 'is-expanded' : 'is-collapsed'}`}
        style={{ maxHeight: expanded || !collapsible ? 'none' : `${collapsedHeight}px` }}
      >
        {children}
      </div>
      {showToggle && (
        <button
          type="button"
          className="analytics-panel-toggle"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? 'Ver menos' : 'Ver más'}
        </button>
      )}
      {footer && <div className="analytics-panel-footer">{footer}</div>}
    </section>
  );
}

